var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5244_36488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 0C0.542188 0 0 0.542188 0 1.2V18.8C0 19.4578 0.542188 20 1.2 20H14.8C15.4578 20 16 19.4578 16 18.8V15.6L15.2 16.4V18.8C15.2 19.025 15.025 19.2 14.8 19.2H1.2C0.975 19.2 0.8 19.025 0.8 18.8V1.2C0.8 0.973438 0.973438 0.8 1.2 0.8H14.8C15.025 0.8 15.2 0.975 15.2 1.2V3.6L16 4.4V1.2C16 0.542188 15.4578 0 14.8 0H1.2ZM15.1375 5.2375C14.9875 5.26406 14.8672 5.37344 14.825 5.51875C14.7828 5.66563 14.8266 5.82188 14.9375 5.925L18.6125 9.6H6.8C6.7875 9.6 6.775 9.6 6.7625 9.6C6.54219 9.61094 6.37031 9.79844 6.38125 10.0188C6.39219 10.2391 6.57969 10.4109 6.8 10.4H18.6125L14.9375 14.075C14.8188 14.1719 14.7641 14.3266 14.7984 14.4766C14.8328 14.625 14.95 14.7422 15.0984 14.7766C15.2484 14.8109 15.4031 14.7563 15.5 14.6375L19.8625 10.2875L20.1375 10L19.8625 9.7125L15.5 5.3625C15.4172 5.27344 15.2969 5.22813 15.175 5.2375C15.1625 5.2375 15.15 5.2375 15.1375 5.2375Z",
    fill: "#929292"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5244_36488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.af2346a9b7014b0986d69355a7bca286.svg";
export { ForwardRef as ReactComponent };